<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">Сортировка</legend>
    <vue-draggable
      v-model="internalSorting"
      :options="{
        ghostClass: 'search-filter__sorting-ghost',
        chosenClass: 'search-filter__sorting-chosen',
        dragClass: 'search-filter__sorting-dragged'
      }"
      element="ul"
      class="search-filter__sorting"
      @update="onOrderChange"
    >
      <li
        v-for="item in internalSorting"
        :key="`${item.field}`"
        class="search-filter__sort-by"
        title="Кликните для сортировки. Двойной клик отменяет выбор."
        @click="onSortItemClick(item)"
        @dblclick="onSortItemDoubleClick(item)"
      >
        <svg
          class="search-filter__sort-by-icon"
          :class="{ _selected: item.active }"
          width="14"
          height="14"
        >
          <use :xlink:href="getSortIcon(item)" />
        </svg>
        <span class="search-filter__sort-by-name">{{ item.label }}</span>
        <svg class="search-filter__draggable-icon" width="16" height="16">
          <use xlink:href="#draggable" />
        </svg>
      </li>
    </vue-draggable>
  </fieldset>
</template>

<script>
import VueDraggable from 'vuedraggable';
import SearchSortingHandler from '@@/search/mixins/SearchSortingHandler';

export default {
  components: {
    VueDraggable
  },

  mixins: [SearchSortingHandler],

  methods: {
    onOrderChange() {
      this.$store.dispatch('setNewSortOrder', this.internalSorting);
    }
  }
};
</script>
